export default __webpack_public_path__ + "static/media/expressjs.493a0dd0.svg";